<template>
  <div class="box6">
    <div class="titleBox">
      <div class="title">抓住变现新风口 拓宽人生“薪”征途</div>
      <div class="subtitle">学习课程后他们成功涨粉50w+，多条视频播放100w+</div>
      <img src="../../../assets/coursePage/media/box6/line.png" alt="" />
    </div>
    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="(item, index) in list"
          :key="index"
          :class="'block' + (index + 1)"
        >
          <div
            class="slide"
            :style="
              `background-image: url(` +
              require(`../../../assets/coursePage/media/box6/${
                index + 1
              }.png`) +
              `)`
            "
          >
            <div class="text-box">
              <p>
                帐号类型：

                {{ item.type }}
                <br />
                粉丝情况：

                {{ item.num }}
              </p>
            </div>
            <div class="seize" v-show="index == 5"></div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box6"></div>
    </div>
    <Box7 />
    <div class="button" @click="openDetail">了解更多学员案例</div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Box7 from "./Box7.vue";
import check from "../../../utils/check";
export default {
  components: {
    swiper,
    swiperSlide,
    Box7,
  },

  data() {
    return {
      list: [
        {
          type: "测评类账号",
          num: "学习课程后涨粉至20w+",
        },
        {
          type: "口播人设IP",
          num: "单个作品发布后涨粉50w，粉丝总数68w+",
        },
        {
          type: "自用好物分享，宝藏店铺安利",
          num: "学习课程后涨粉38.5w，粉丝总数93w+",
        },
        {
          type: "美食制作分享账号",
          num: "学习课程后涨粉至4w+",
        },
        {
          type: "独立剪辑师人设IP",
          num: "单月最高涨粉10w, 目前粉丝22w+",
        },
        {
          type: "搞笑人设IP",
          num: "学习课程后涨粉至26w+",
        },
      ],
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 20,
        // effect: "left",
        pagination: {
          el: ".swiper-pagination-box6",
        },
      },
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(check.getUrlParam("subject"))) {
        window.location.href = localStorage.getItem(
          check.getUrlParam("subject")
        );
      } else {
        this.clickZiXun()
      }
       this.mai("短视频-就业课","进入学习",0,null)
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/media/box6/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
  .seize {
    width: 20px;
    background: red;
  }
  .titleBox {
    text-align: center;
    .title {
      font-size: 40px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: #0d004d;
      line-height: 62px;
    }
    .subtitle {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #826aff;
      line-height: 40px;
      margin-top: 48px;
    }
    img {
      width: 750px;
      height: 20px;
    }
  }
  .subject-content {
    position: relative;
    margin-top: 48px;

    width: 100%;
    box-sizing: border-box;
  }

  .swiper-slide {
    margin-left: 32px;
    width: 380px;
    height: 680px;
    background-size: contain;
    display: flex;

    overflow: hidden;
    position: relative;
    .slide {
      width: 380px;
      height: 680px;
      background-size: contain;
    }
    .text-box {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      position: absolute;
      top: 508px;
      left: 24px;

      padding-right: 24px;

      box-sizing: border-box;
      p {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
      }
      // transform: translateY(286px);
      opacity: 1;
      transition: 0.5s all;
    }
  }
  .swiper-slide:nth-child(6) {
    width: 412px;
  }
  .swiper-pagination-box6 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: #b7a9ff;
    border-radius: 3px;
    display: none;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #b7a9ff;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #775cff;
    border-radius: 3px;
  }
  .button {
    width: 690px;
    height: 96px;
    background: linear-gradient(180deg, #9896ff 0%, #6b62fb 100%);
    box-shadow: 0px 10px 20px 0px #d9dbfc, 0px 4px 16px 0px #bebbff;
    border-radius: 48px;
    margin: 96px auto 0;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 96px;
    text-shadow: 0px 6px 5px rgba(127, 122, 253, 0.77);
    text-align: center;
  }
}
</style>
